/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import {
  isIPhone13,
  isIPad13,
  isIPod13,
  isIOS,
  isAndroid,
} from "react-device-detect";
import gradientIcon from "../../images/tririga-favicon-gradient.svg";
import favIcon196PX from "../../images/tririga-favicon-196px.png";
import favIcon180PX from "../../images/tririga-favicon-180px.png";
import favIcon120PX from "../../images/tririga-favicon-120px.png";
import favIcon167PX from "../../images/tririga-favicon-167px.png";
import favIcon152PX from "../../images/tririga-favicon-152px.png";

export default class TriFaviconHandler {
  handle() {
    let link =
      document.querySelector('link[rel="shortcut icon"]') ||
      document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.id = "favicon";
      link.rel = "shortcut icon";
      document.head.appendChild(link);
    }

    if (isAndroid) {
      link.rel = "shortcut icon";
      link.href = favIcon196PX;
    } else if (isIPhone13) {
      link.rel = "apple-touch-icon";
      link.href = favIcon120PX;
    } else if (isIPad13) {
      link.rel = "apple-touch-icon";
      link.href = favIcon167PX;
    } else if (isIPod13) {
      link.rel = "apple-touch-icon";
      link.href = favIcon152PX;
    } else if (isIOS) {
      link.rel = "apple-touch-icon";
      link.href = favIcon180PX;
    } else {
      // Default favicon
      link.href = gradientIcon;
    }
  }
}
